import { Slider } from '@change/ds-forms';
import { cn } from '@change/ds-utils';

import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { AmountInput } from '../../AmountInput';
import { ValidationErrorMessage } from '../ValidationErrorMessage';

import { useSliderAmountSelector } from './hooks/useSliderAmountSelector';

export function SliderAmountSelector(): JSX.Element {
	const {
		data: { amount, currencySymbol, placeholder, maxValue, minValue, errorMessage, formatValue },
		actions: { onSliderChange, onSliderChangeEnd, onInputChange, onInputFocus },
	} = useSliderAmountSelector();

	const isMobileDevice = useIsMobile();

	return (
		<div className="mx-auto w-full max-w-2xl">
			<div className={cn({ 'px-5 pt-2 pr-10': !isMobileDevice, 'sm:px-0 sm:pt-2 sm:pr-0': isMobileDevice })}>
				<Slider
					data-qa="slider-amount-selector"
					// TODO: Translate this during productization
					ariaLabel="Amount"
					showRangeLabels
					showTooltip
					value={amount}
					onChange={onSliderChange}
					onChangeEnd={onSliderChangeEnd}
					minValue={minValue}
					maxValue={maxValue}
					formatValue={formatValue}
				/>
			</div>
			<div className="-mt-2">
				<AmountInput
					currencySymbol={currencySymbol}
					errorMessage={errorMessage}
					onChange={onInputChange}
					onFocus={onInputFocus}
					value={amount}
					placeholder={placeholder}
					height="56px"
				/>
			</div>
			<ValidationErrorMessage />
		</div>
	);
}
